import { GraduationCap } from "lucide-react";

export const TrainingIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.93335 10.9564C4.64952 13.0312 4.47712 15.1394 4.42205 17.2754C7.43899 18.4791 10.3085 19.953 12.9973 21.6654C15.6862 19.953 18.5557 18.4791 21.5726 17.2754C21.5176 15.1394 21.3452 13.0312 21.0613 10.9565M4.93335 10.9564C4.02106 10.6634 3.09772 10.3934 2.16406 10.1471C5.54501 7.88243 9.17135 5.92951 12.9974 4.33203C16.8234 5.92952 20.4498 7.88244 23.8307 10.1471C22.897 10.3934 21.9737 10.6634 21.0613 10.9565M4.93335 10.9564C7.73283 11.8557 10.4281 12.9716 12.9974 14.2835C15.5666 12.9717 18.2619 11.8557 21.0613 10.9565M7.52806 15.7881C7.95957 15.7881 8.30938 15.4538 8.30938 15.0415C8.30938 14.6291 7.95957 14.2948 7.52806 14.2948C7.09654 14.2948 6.74673 14.6291 6.74673 15.0415C6.74673 15.4538 7.09654 15.7881 7.52806 15.7881ZM7.52806 15.7881V12.129C9.29018 11.0827 11.1155 10.1245 12.9973 9.26068M5.69729 20.7585C6.9178 19.5921 7.52805 18.0635 7.52806 16.5348V15.0415"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    // <GraduationCap stroke="var(--color-policy-orange)" strokeWidth={1.5} />
  );
};

export default TrainingIcon;